import { SUBMIT_ACTIVITY_FEEDBACK_SUCCESS, SUBMIT_ACTIVITY_FEEDBACK } from '../../actions/ActionTypes.js';

const submitActivityFeedbackSuccess = (state, action) => {
    return {
        ...state,
        ...action.activityFeedback,
        receivedAt: Date.now()
    };
};

const handlers = {
    [SUBMIT_ACTIVITY_FEEDBACK_SUCCESS]: submitActivityFeedbackSuccess
};

export default function atpActivityFeedback(state = {}, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// Activity Feedback Action
export function submitActivityFeedback(feedBack, activityId) {
    return {
        type: SUBMIT_ACTIVITY_FEEDBACK,
        payload: {
            activityId,
            feedBack
        }
    };
}
